import {Component, OnInit} from "@angular/core";
import {DialogRef} from "@fundamental-ngx/core/dialog";
import {AppConfigService} from "../../../service/services/misc/app-config/app-config.service";
import {SwaService} from "../../../service/services/misc/swa/swa.service";

@Component({
    selector: 'app-user-info',
    templateUrl: './user-info.component.html',
    styleUrls: ['./user-info.component.scss'],
    standalone: false
})
export class UserInfoDialogComponent implements OnInit {
    public name: string;
    public id: string;
    public email: string;
    public idp: string;

    constructor(
        public dialogRef: DialogRef,
        private _appConfigService: AppConfigService,
        private _swaService: SwaService
    ) {}

    ngOnInit(): void {
        const conf = this._appConfigService.getUserInfoModel();
        this.name = conf.first_name + " " + conf.last_name;
        this.email = conf.email;
        this.id = conf.email;
        this.idp = conf.oidc;
    }
}